export default {
  title: 'Product Management',
  productList: 'Product List',
  addProduct: 'Add Product',
  editProduct: 'Edit Product',
};
